export const baseUrl = 'https://mirgroupbd.com/dev/admin/';
